__turbopack_context__.v({
  "controlsWrapper": "date-controls-module-scss-module__tiWoNW__controlsWrapper",
  "dashContainer": "date-controls-module-scss-module__tiWoNW__dashContainer",
  "dateFieldContainer": "date-controls-module-scss-module__tiWoNW__dateFieldContainer",
  "dateLabel": "date-controls-module-scss-module__tiWoNW__dateLabel",
  "inputWrapper": "date-controls-module-scss-module__tiWoNW__inputWrapper",
  "legend": "date-controls-module-scss-module__tiWoNW__legend",
  "yearInput": "date-controls-module-scss-module__tiWoNW__yearInput",
});
